import React from 'react';

import { PropertiesPanel } from '@paragon/layout-models';

import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { BasicInsertionProperties } from '../../../controls/basic-insertion/BasicInsertionProperties';
import { useAppSelector } from '../../../hooks';
import InsertionPanelContainer from './InsertionPanelContainer';

export function ReferenceLineInsertionSubPanel() {
  const activeComponentDesign = useAppSelector(getActiveComponentDesign);
  const insertionInfo = useAppSelector(({ application: { insertingObjectInfo } }) =>
    insertingObjectInfo && insertingObjectInfo.type === 'referenceLine' ? insertingObjectInfo : null,
  );

  if (activeComponentDesign?.component.referenceLines == null || insertionInfo == null) return null;

  return (
    <InsertionPanelContainer hideSubmitButton>
      <PropertiesPanel title="Reference Line Insertion">
        <BasicInsertionProperties type="referenceLine" />
      </PropertiesPanel>
    </InsertionPanelContainer>
  );
}
